export default {
      id: "aure-side-by-side-usage",
      viewBox: "0 0 200.5 106",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#aure-side-by-side",
      toString: function () {
        return this.url;
      }
    }